<template>
    <div class="slideAppTop">
        <div class="slideContainer">
            <div class="slideShow">
                <carousel v-bind:presentation="presentation" v-bind:progressiveReveal="progressiveReveal" v-bind:slideList="slideList" v-bind:syncSlideNum="syncSlideNum" v-bind:syncSlide="syncSlide" v-on:calculatedSlide="slideCalculated($event)" v-on:syncSlideEvent="changeSyncSlide($event)"></carousel>
            </div>
            <div class="slideMenu">
                <div class="slideLeftMenu">
                    <div class="slideNumber">{{$t('str.Of', {current: currentSlide + 1, count: slideList.length})}}</div>
                    <div v-if="!syncSlide" class="syncSlides" v-on:click="changeSyncSlide(true)">
                        <img src="../assets/icons/refresh.svg">
                    </div>
                </div>
                <div class="slideRightMenu">
                    <div class="likeButton" v-on:click="likeSlide">
                        <img v-if="slideLiked" src="../assets/icons/like-red.svg">
                        <img v-else src="../assets/icons/like.svg">
                    </div>
                    <div class="twitterButton" v-on:click="openTweetUI">
                        <img v-if="!slideTweeted" src="../assets/icons/twitter-bird-only.svg">
                        <img v-else src="../assets/icons/twitter-bird-only-red.svg">
                    </div>
                    <div class="shareButton" ref="shareBtn" v-on:click="toggleShareOptions($event)">
                        <img src="../assets/icons/share.svg">
                    </div>
                    <!-- <div class="downloadButton" v-on:click="downloadSlides">
                        <img src="../assets/icons/download.svg">
                    </div> -->
                </div>
            </div>
        </div>
        <tweetslideui v-if="tweet" v-on:closeTweetUI="toggleTweetIcon" :twitterProfile="twitterProfile" :currentSlide="currentSlide" :slideList="slideList" :user="user" :socialMedia="socialMedia"></tweetslideui>
        <shareoptions v-if="!!anchorOptions" :slideList="slideList" :currentSlide="currentSlide" :presentation="presentation" :anchor="anchorOptions" v-on:close="closeShare"></shareoptions>
    </div>
</template>

<script>
// TODO: add button to go back to first slide
// TODO: when web page is refreshed, should start at last slide user had open, not default to first slide
import Carousel from '@/components/Carousel';
import TweetSlideUI from '@/components/TweetSlideUI';
import ShareOptions from '@/components/ShareOptions';
import {EventBus, LeadBus} from '../router/index';
import Document from '../javascript-classes/JS-DOCX/Document';
import Notes from '../javascript-classes/Notes';
import StorageUtils from '../javascript-classes/utils/storage.js';
import CookieUtils from '../javascript-classes/utils/storage.js';

export default {
    components: {
        carousel: Carousel,
        tweetslideui: TweetSlideUI,
        shareoptions: ShareOptions
    },

    props: {
        presentation: {},
        user: {},
        slideList: {},
        syncSlideNum: {},
        slideNum: {},
        progressiveReveal: {},
        service: {}
    },

    data () {
        return {
            currentSlide: 0,
            syncSlide: true,
            slideLiked: false,
            tweet: false,
            twitterProfile: {},
            anchorOptions: undefined,
            notes: {},
            slideTweeted: undefined
        };
    },

    computed: {
        socialMedia() {
            if (this.presentation && this.presentation.props && this.slideList && this.slideList[this.currentSlide] !== undefined
                && this.presentation.props.Resources && this.presentation.props.Resources[this.slideList[this.currentSlide].slideId]) {
                return this.presentation.props.Resources[this.slideList[this.currentSlide].slideId].SocialMedia;
            }
        }
    },

    mounted() {
        EventBus.$emit('getSlides', this.presentation.id);
        this.updateIsSlideTweeted();
    },

    watch: {
        slideList() {
            this.updateIsSlideTweeted();
            this.slideLiked = this.slideList[this.currentSlide].liked === true;
        },

        currentSlide() {
            this.updateIsSlideTweeted();
        }
    },

    methods: {
        slideCalculated(newSlide) {
            this.currentSlide = newSlide;
            this.$emit('newCurrentSlide', newSlide);
            // TODO: ensure we check if slide is liked for first slide when loaded
            this.slideLiked = this.slideList[this.currentSlide].liked === true;
        },

        changeSyncSlide(newVal) {
            this.syncSlide = newVal;
        },

        likeSlide() {
            if (this.slideLiked === false) {
                this.slideLiked = true;
                EventBus.$emit('likeSlide', this.slideList[this.currentSlide]);
                EventBus.$emit('getSlides', this.presentation.id);
            }
        },

        getUserSocialMediaProfile(socialMedia) {
            var socialMediasCount = this.user.social.length;

            for (let i = 0; i < socialMediasCount; i++) {
                if (this.user.social[i].network === socialMedia) {
                    return [this.user.social[i], i];
                }
            }
        },

        openTweetUI() {
            if (this.slideTweeted && confirm(this.$t('str.YouHaveAlreadyTweetedThisSlideDoYouWantToTweetItAgain')) !== true) {
                return;
            }

            this.twitterProfile = this.getUserSocialMediaProfile('Twitter');

            if (this.twitterProfile === null) {
                alert(this.$t('str.YouHaveNotConnectedATwitterAccountRedirecting'));

                let url = this.service.getLoginUrl('twitter');

                if (!url) {
                    return;
                }

                url += `&u=${this.user.id}`;

                window.open(url); 
            } else {
                this.tweet = !this.tweet;
            }
        },

        toggleTweetIcon() {
            this.tweet = false;
            this.updateIsSlideTweeted();
        },

        toggleShareOptions(event) {
            if (this.anchorOptions) {
                this.anchorOptions = undefined;
            } else if (event) {
                this.anchorOptions = event.srcElement;
            }
        },

        downloadSlides() {
            LeadBus.$emit('recordLead', {type: 'slides-download-pdf', data: {}});
            let doc = new Document();
            this.currentSlideId = this.slideList[this.currentSlide].slideId;
            this.userId = this.user.id;

            let str = StorageUtils.getItem(this.userId);

            if (!str) {
                return;
            }

            let notesJson;

            try {
                notesJson = JSON.parse(str);
            } catch(e) {
                return;
            }

            this.notes = new Notes(this.userId, notesJson.content);

            // check if there are notes for current slide
            for (let i = 0; i < this.slideList.length; i++) {
                doc.addImage(this.slideList[i].url, this.notes.get(this.presentation.id, this.slideList[i].slideId, ""));  
            }
        },

        updateIsSlideTweeted() {
            if (!this.user || this.currentSlide === undefined || !this.slideList || !this.slideList[this.currentSlide]) {
                return false;
            }

            let key = this.user.id + "_tweets";
            let tweets = CookieUtils.getItem(key);

            if (!tweets) {
                return false;
            }

            try {
                tweets = JSON.parse(tweets);
            } catch(e) {
                console.log(e);
                return false;
            }

            this.slideTweeted = tweets[this.slideList[this.currentSlide].id];
        },

        closeShare() {
            this.anchorOptions = undefined;
        }
    }
};

</script>

<style lang="scss">

.slideAppTop {
    align-items: center;
    display: flex;
    justify-content: center;
    position: relative;

    .slideContainer {
        .slideMenu {
            display: flex;
            justify-content: space-between;

            .slideLeftMenu{
                display: flex;
                align-items: left;
                justify-content: left;
                margin: 12px 0 0 12px;

                .slideNumber {
                    color: #fff;
                    font-family: 'Poppins', sans-serif;
                    font-size: .8em;
                }

                .syncSlides {
                    margin-left: 15px;
                }
            }

            .slideRightMenu {
                display: flex;
                align-items: right;
                justify-content: right;
                margin: 10px 15px 0 0;

                img {
                    margin-left: 12px;
                    margin-right: 12px;
                }                    
            }
        }

        img {
            width: 1em;
            height: 1em;
            cursor: pointer;
        }
    }
}

</style>


// WEBPACK FOOTER //
// VisualPanel.vue?08da4f4f